document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.home-section--title').forEach((title) => {
        const text = title.textContent.trim(); // Get the text and trim whitespace
        const lastSpaceIndex = text.lastIndexOf(' ');

        if (lastSpaceIndex !== -1) {
            // For multiple-word titles
            const beforeLastWord = text.slice(0, lastSpaceIndex);
            const lastWord = text.slice(lastSpaceIndex + 1);
            title.innerHTML = `${beforeLastWord} <span class="highlight">${lastWord}</span>`;
        } else if (text) {
            // For single-word titles
            title.innerHTML = `<span class="highlight">${text}</span>`;
        }
    });
});


document.addEventListener("DOMContentLoaded", () => {
  const slider = document.querySelector(".product-slider");
  const slides = document.querySelectorAll(".product-slide");
  const nextButton = document.querySelector(".slider-next");
  const prevButton = document.querySelector(".slider-prev");

  if (!slider || slides.length === 0 || !nextButton || !prevButton) {
    console.error("Slider or buttons not found. Ensure the HTML structure is correct.");
    return;
  }

  // Get the width of a single slide dynamically
  const slideWidth = slides[0].offsetWidth;

  nextButton.addEventListener("click", () => {
    slider.scrollBy({
      left: slideWidth,
      behavior: "smooth",
    });
  });

  prevButton.addEventListener("click", () => {
    slider.scrollBy({
      left: -slideWidth,
      behavior: "smooth",
    });
  });

});


//seo collection description read more accordion 
document.addEventListener("DOMContentLoaded", function () { 
    document.querySelectorAll("#shopify-section-template--25562930413853__dynamic_rich_text_Hizfri .metafield-rich_text_field p").forEach(paragraph => {
        const fullHTML = paragraph.innerHTML.trim();
        const charLimit = 300;

        if (fullHTML.length > charLimit) {
            const shortHTML = fullHTML.substring(0, charLimit) + "...";

            paragraph.innerHTML = `<div class="text-preview">${shortHTML}</div>
                                   <div class="full-text hidden">${fullHTML}</div>
                                   <a href="#" class="read-more">Read More</a>`;

            const readMoreLink = paragraph.querySelector(".read-more");
            readMoreLink.addEventListener("click", function (event) {
                event.preventDefault();
                const preview = paragraph.querySelector(".text-preview");
                const full = paragraph.querySelector(".full-text");

                if (full.classList.contains("hidden")) {
                    preview.style.display = "none";
                    full.classList.remove("hidden");
                    readMoreLink.textContent = "Read Less";
                } else {
                    preview.style.display = "block";
                    full.classList.add("hidden");
                    readMoreLink.textContent = "Read More";
                }
            });
        }
    });
});


//two-grid description read more accordion 
(function () {
  const SECTION_ID = ".shopify-section[id$='__dynamic_grid_8anLBH']";
  const CHAR_LIMIT = 300;
  const PROCESSED_CLASS = "has-readmore-grid";

  function truncateHTMLWithEllipsis(html, limit) {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;

    let totalChars = 0;
    let truncated = "";

    function walk(node) {
      for (let child of node.childNodes) {
        if (totalChars >= limit) return;

        if (child.nodeType === Node.TEXT_NODE) {
          const remaining = limit - totalChars;
          if (child.textContent.length <= remaining) {
            truncated += child.textContent;
            totalChars += child.textContent.length;
          } else {
            truncated += child.textContent.slice(0, remaining);
            totalChars = limit;
            return;
          }
        } else if (child.nodeType === Node.ELEMENT_NODE) {
          truncated += `<${child.nodeName.toLowerCase()}`;
          for (let attr of child.attributes) {
            truncated += ` ${attr.name}="${attr.value}"`;
          }
          truncated += `>`;
          walk(child);
          truncated += `</${child.nodeName.toLowerCase()}>`;
        }
      }
    }

    walk(tempDiv);

    // Add ellipsis inside the last <p> tag if one exists
    const tempWrap = document.createElement("div");
    tempWrap.innerHTML = truncated;

    const lastP = tempWrap.querySelector("p:last-of-type");
    if (lastP) {
      lastP.innerHTML = lastP.innerHTML.trim() + "...";
    } else {
      tempWrap.innerHTML = tempWrap.innerHTML.trim() + "...";
    }

    return tempWrap.innerHTML;
  }

  function initReadMoreInSection() {
    const section = document.querySelector(SECTION_ID);
    if (!section) return;

    section.querySelectorAll(".prod-grid-description .metafield-rich_text_field").forEach(field => {
      if (field.classList.contains(PROCESSED_CLASS)) return;

      const originalHTML = field.innerHTML.trim();
      const plainText = field.textContent.trim();

      if (!plainText || plainText.length <= CHAR_LIMIT) {
        field.classList.add(PROCESSED_CLASS);
        return;
      }

      const truncatedHTML = truncateHTMLWithEllipsis(originalHTML, CHAR_LIMIT);

      const wrapper = document.createElement("div");
      wrapper.className = "readmore-wrapper-grid " + PROCESSED_CLASS;

      const previewDiv = document.createElement("div");
      previewDiv.className = "text-preview-grid";
      previewDiv.innerHTML = truncatedHTML;

      const fullDiv = document.createElement("div");
      fullDiv.className = "full-text-grid hidden";
      fullDiv.innerHTML = originalHTML;

      const toggle = document.createElement("a");
      toggle.href = "#";
      toggle.className = "read-more-grid";
      toggle.textContent = "Read More";

      wrapper.appendChild(previewDiv);
      wrapper.appendChild(fullDiv);
      wrapper.appendChild(toggle);

      field.parentNode.replaceChild(wrapper, field);

      toggle.addEventListener("click", function (e) {
        e.preventDefault();
        const isHidden = fullDiv.classList.contains("hidden");
        if (isHidden) {
          fullDiv.classList.remove("hidden");
          previewDiv.classList.add("hidden");
          toggle.textContent = "Read Less";
        } else {
          fullDiv.classList.add("hidden");
          previewDiv.classList.remove("hidden");
          toggle.textContent = "Read More";
        }
      });
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initReadMoreInSection();
    setTimeout(initReadMoreInSection, 700);

    const section = document.querySelector(SECTION_ID);
    if (section) {
      const observer = new MutationObserver(() => initReadMoreInSection());
      observer.observe(section, { childList: true, subtree: true });
    }
  });
})();



//smart tabs customisation
document.addEventListener("DOMContentLoaded", function () {
  const ANIM_MS = 350; // animation duration in ms
    const MOBILE_BREAKPOINT = 767; // max width to consider mobile (px)

  // Only initialize on desktop
  if (window.innerWidth <= MOBILE_BREAKPOINT) return;

  function initSmartTabsOneSpot() {
    const tabs = Array.from(document.querySelectorAll(".smart-tabs-navigation-li"));
    const contents = Array.from(document.querySelectorAll(".smart-tabs-content-block"));

    if (!tabs.length || !contents.length) return false;

    // Ensure there's a single wrapper for all panels
    let wrapper = document.querySelector(".smart-tabs-content-wrapper");
    if (!wrapper) {
      wrapper = document.createElement("div");
      wrapper.className = "smart-tabs-content-wrapper";
      contents[0].parentNode.insertBefore(wrapper, contents[0]);
    }

    // Move all content blocks into the wrapper (if not already)
    contents.forEach((c) => {
      if (c.parentNode !== wrapper) wrapper.appendChild(c);
    });

    const panels = Array.from(wrapper.querySelectorAll(".smart-tabs-content-block"));

    // Wrapper styles
    wrapper.style.overflow = "hidden";
    wrapper.style.height = "0px";
    wrapper.style.transition = `height ${ANIM_MS}ms ease`;
    wrapper.dataset.animating = "false";

    // Initialize panels (hidden)
    panels.forEach((p) => {
      p.style.display = "none";
      p.dataset.open = "false";
      p.style.boxSizing = "border-box";
    });

    // Measure a panel's full height
    function measurePanelHeight(panel) {
      const clone = panel.cloneNode(true);
      clone.style.visibility = "hidden";
      clone.style.position = "absolute";
      clone.style.left = "-99999px";
      clone.style.top = "0";
      clone.style.width = Math.max(wrapper.clientWidth || 0, panel.clientWidth || 0, 200) + "px";
      clone.style.maxHeight = "none";
      clone.style.display = "block";
      document.body.appendChild(clone);
      const h = clone.scrollHeight;
      document.body.removeChild(clone);
      return h;
    }

    function getCurrentlyOpenPanel() {
      return panels.find((p) => p.dataset.open === "true");
    }

    // Switch to a new panel
    function switchToPanel(panel, tab) {
      if (wrapper.dataset.animating === "true") return;
      wrapper.dataset.animating = "true";

      const currentlyOpen = getCurrentlyOpenPanel();

      // Hide previous panel instantly
      if (currentlyOpen && currentlyOpen !== panel) {
        const prevIndex = panels.indexOf(currentlyOpen);
        if (prevIndex >= 0) tabs[prevIndex].classList.remove("smart-tabs-navigation-li-active");
        currentlyOpen.style.display = "none";
        currentlyOpen.dataset.open = "false";
      }

      // Set active tab
      tabs.forEach((t) => t.classList.remove("smart-tabs-navigation-li-active"));
      if (tab) tab.classList.add("smart-tabs-navigation-li-active");

      // Show new panel (so we can measure it)
      panel.style.display = "block";
      panel.dataset.open = "true";

      // Measure heights
      const startHeight = wrapper.getBoundingClientRect().height; // current wrapper height
      const targetHeight = measurePanelHeight(panel);             // height of new panel

      // Apply smooth transition from current height → targetHeight
      wrapper.style.height = startHeight + "px";                  // start from current height
      wrapper.style.transition = `height ${ANIM_MS}ms ease`;

      // Trigger the transition
      requestAnimationFrame(() => {
        wrapper.style.height = targetHeight + "px";
      });

      // After transition ends, set height to auto
      function onFinishOpen() {
        wrapper.removeEventListener("transitionend", onFinishOpen);
        wrapper.style.transition = "none";
        wrapper.style.height = "auto";  // flexible height
        wrapper.dataset.animating = "false";
      }

      wrapper.addEventListener("transitionend", onFinishOpen);

      // Fallback in case transitionend doesn't fire
      setTimeout(onFinishOpen, ANIM_MS + 150);
    }


    // Close current panel
    function closePanel(panel, tab) {
      if (wrapper.dataset.animating === "true") return;
      wrapper.dataset.animating = "true";

      const startHeight = wrapper.getBoundingClientRect().height;
      wrapper.style.transition = `height ${ANIM_MS}ms ease`;
      wrapper.style.height = startHeight + "px";

      requestAnimationFrame(() => {
        wrapper.style.height = "0px";
      });

      function onFinishClose() {
        wrapper.removeEventListener("transitionend", onFinishClose);
        panel.style.display = "none";
        panel.dataset.open = "false";
        if (tab) tab.classList.remove("smart-tabs-navigation-li-active");
        wrapper.dataset.animating = "false";
        wrapper.style.height = "0px";
      }

      wrapper.addEventListener("transitionend", onFinishClose);
      setTimeout(onFinishClose, ANIM_MS + 150);
    }

    // Click handler
    tabs.forEach((tab, i) => {
      tab.addEventListener("click", function (e) {
        e.preventDefault();
        const panel = panels[i];
        if (!panel) return;

        if (panel.dataset.open === "true") {
          closePanel(panel, tab);
        } else {
          switchToPanel(panel, tab);
        }
      });
    });

    // Open first tab by default
    if (tabs[0] && panels[0]) {
      tabs.forEach((t) => t.classList.remove("smart-tabs-navigation-li-active"));
      panels.forEach((p) => {
        p.style.display = "none";
        p.dataset.open = "false";
      });

      tabs[0].classList.add("smart-tabs-navigation-li-active");
      panels[0].style.display = "block";
      panels[0].dataset.open = "true";

      const firstHeight = measurePanelHeight(panels[0]);
      wrapper.style.transition = "none";
      wrapper.style.height = firstHeight + "px";

      requestAnimationFrame(() => {
        wrapper.style.height = "auto";
      });
    }

    return true;
  }

  // Initialize or observe for late DOM load
  if (!initSmartTabsOneSpot()) {
    const observer = new MutationObserver(() => {
      if (initSmartTabsOneSpot()) {
        observer.disconnect();
        console.log("SmartTabs initialized via MutationObserver ✅");
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  } else {
    console.log("SmartTabs initialized ✅");
  }
});

